import { NumberLiteralType } from 'typescript';
import { Extension } from '../profile/profile/profile.model';

export class MemberSearchFilter {
  firstName: string;
  lastName: string;
  diocese: number;
  department: number;
  superGroup: number;
  group: number;
  email: string;
  phone: string;
  gender: boolean;
  maritalStatus: number;
  occupation: number;
  account: number;
  role: number;
  age: number[];
  grade: number[]; 
  city: string[];
  state: string[];
  zip: string[];
  membership: boolean;
  picture: boolean;
  category: number;
  service: number;
  attendanceStartDate: Date;
  attendanceEndDate: Date;
  attendanceDateRange: number;
  followupDateRange: number; 
  donationDateRange: number;
  frequency: number;
  frequencyType: number;
  attendanceStatus: number;
  outReachStatus: number; 
  outReachTask: number;
  outReachStartDate: Date;
  outReachEndDate: Date;
  outReachAssignee: number;
  donationStartDate: Date;
  donationEndDate: Date;
  singleDonationMode: boolean;
  donationStartRange: number;
  donationEndRange: number;
  includeAccounts: number;
  result: number;
  leaders: boolean;
  has_role: string;
  note_selection: number;
  birthdayMonth: number;
  birthdayDay: number;
  massText: boolean;
  notification: number;
  tag: number;
  extensionValues: Extension[];
}
